import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersAiChatRoomsMutateResponseType,
  ApiMembersAiChatRoomsCreateRequestType,
} from "~/domains";

type RequestDataType = {
  body: ApiMembersAiChatRoomsCreateRequestType;
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiMembersAiChatRoomsMutateResponseType>(
      "/api/members/ai_chat_rooms",
      {
        aiChatRoom: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersAiChatRoomsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ApiMembersAiChatRoomsMutateResponseType> => {
  return useMutation(request, { ...options });
};
